<template>
<div>
  <v-dialog
    v-model="show_totebag_modal"
    :max-width="maxWidth"
    @click:outside="closePopup"
  >
    <v-card>
      <v-toolbar dark flat color="primary" dense>
        <v-toolbar-title>Tote Bag</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closePopup">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-row no-gutters>
        <v-col cols="9">
          <v-card flat>
            <v-card-subtitle class="pa-2">
              <v-tabs >
                <v-tab class="text-capitalize" @click="is_document = true">My Document</v-tab>
                <v-tab class="text-capitalize" @click="is_document = false">My Itinerary</v-tab>
              </v-tabs>
            </v-card-subtitle>
            <v-card-text>
              <v-list v-if="is_document">
                <v-btn color="red darken-3" v-if="selected.length" dark @click="removeDocument">Remove</v-btn>
                <div v-for="(item, index) in totebag_list" :key="index">
                  <v-list-item>
                    <v-checkbox v-model="selected" :value="item.tote_bag_id"></v-checkbox>
                    <!--<v-btn color="red" icon class="mx-1">
                      <v-icon>mdi-file-pdf-box-outline</v-icon>
                    </v-btn>-->
                    <v-btn color="primary" class="mx-1"
                    @click="openVideo(item.session.pre_recorded_video)"
                    :disabled="!item.session.pre_recorded_video"
                    v-if="item.content_type==1">
                    {{  (item.session.pre_recorded_video) ? 'View' : 'Available soon' }}
                    </v-btn>
                    <v-btn color="primary" class="mx-1" :href="item.resource.file" target="_blank" v-if="item.content_type==2" > View </v-btn>
                    <v-list-item-content class="mx-4" v-if="item.content_type==1">
                      <v-list-item-title>{{item.session.title}}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content class="mx-4" v-if="item.content_type==2">
                      <v-list-item-title>{{item.resource.title}}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon  v-if="item.content_type!==1" :href="getFileUrl(item.resource)" target="_blank">
                        <v-icon>mdi-download-circle</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="index != totebag_list.length - 1"
                  ></v-divider>
                </div>
                <div v-if="totebag_list.length == 0">
                  No Document Found!
                </div>
              </v-list>
              <v-list v-if="!is_document">
                <div v-for="(item, index) in agenda_list" :key="index">
                  <v-list-item>
                    <span class="col-3">{{ getTimeSlot(item.session) }} </span>
                    <v-btn color="primary" :to="'/session/'+item.session.session_id" @click="closePopup">
                      View
                    </v-btn>
                    <v-list-item-content class="mx-4">
                      <v-list-item-title>{{item.session.title}}</v-list-item-title>
                    </v-list-item-content>
                    <v-btn icon @click="addEvent(item.session.session_id)">
                      <v-icon>mdi-calendar-month-outline</v-icon>
                    </v-btn>
                    <v-btn icon @click="removeAgenda(item.agenda_id)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item>
                  <v-divider
                    v-if="index != agenda_list.length - 1"
                  ></v-divider>
                </div>
                <div v-if="agenda_list.length == 0">
                  No Itinerary Found!
                </div>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="3">
          <div class="d-flex align-center" :style="{height : '100%'}">
             <div class="d-flex flex-column self-center" style="width:100%">
                <v-card class="pa-2" outlined tile @click="$helper.openUrl(totebag_advertise.ADVERTISE_1_LINK)" :ripple="totebag_advertise.ADVERTISE_1_LINK!=null">
                  <v-img :src="totebag_advertise.ADVERTISE_1"/>
                </v-card>
                <v-card class="pa-2" outlined tile @click="$helper.openUrl(totebag_advertise.ADVERTISE_2_LINK)" :ripple="totebag_advertise.ADVERTISE_2_LINK!=null">
                  <v-img :src="totebag_advertise.ADVERTISE_2"/>
                </v-card>
             </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
  <v-dialog v-model="show_preview" max-width="50%">
      <v-card>
        <v-card-text class="pt-2 rounded-lg px-0 py-0">
          <video :src="preview_data" width="100%" v-if="preview_data" controls controlsList="nodownload"></video>
        </v-card-text>
        <v-btn style="position:absolute;top:0px;right:10px" color="red" dark fab small @click="show_preview = false">          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
  </v-dialog>
</div>
</template>
<script>
import axios from "@/helper/axios";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "TotebagPopup",
  data() {
    return {
      selected : [],
      is_document: true,
      preview_data: null,
      show_preview: false,
      baseURL : axios.defaults.baseURL
    };
  },
  watch: {
    show_totebag_modal(value) {
      if (value) {
        this.fetchTotebag();
        this.fetchAgenda();
        this.fetchAdertisement()
      }
    },
    show_preview : function(value){
      if(!value){
       this.preview_data = null
      }
    }
  },
  computed: {
    ...mapState("totebag", ["show_totebag_modal", "totebag_list","agenda_list","totebag_advertise"]),
    ...mapState("utils", ["maxWidth"]),
  },
  methods: {
    ...mapActions("totebag", ["fetchTotebag","fetchAdertisement","fetchAgenda"]),
    ...mapMutations("totebag", ["setTotebagData"]),
    ...mapMutations("utils", ["setAlert"]),
    closePopup() {
      this.setTotebagData({
        key: "show_totebag_modal",
        data: false,
      });
    },
    getTimeSlot(session) {
      return (
        this.moment(session.start_time).format("ddd, MMM Do h:mm a") +
        " - " +
        this.moment(session.end_time).format("h:mm a")
      );
    },
    addEvent(session_id) {
      let _self = this;
      this.loading = "secondary";
      axios.post(`session/add_event`, {session_id:session_id})
        .then((response) => {
          let response_data = response.data;
          if (response_data.status) {
            _self.setAlert({
              show: true,
              variant: "success",
              message: response_data.message,
              dismissCountDown: 5000,
            });
          }
          else {
            let errors = response_data.error;
            for (let key in errors) {
              _self.setAlert({
                show: true,
                variant: "danger",
                message: errors[key].message,
                dismissCountDown: 5000,
              });
            }
          }
          _self.loading = false;
        })
        .catch((e) => {
          console.log(e);
          _self.loading = false;
        });
    },
    removeDocument(){
      let _self = this;
      this.loading = "secondary";
      axios.post(`tote_bag/delete`, {selected_id:this.selected})
      .then((response) => {
        let response_data = response.data;
        if (response_data.status) {
          _self.selected = []
          _self.fetchTotebag();
          _self.setAlert({
            show: true,
            variant: "success",
            message: response_data.message,
            dismissCountDown: 5000,
          });
        }
        else {
          let errors = response_data.error;
          for (let key in errors) {
            _self.setAlert({
              show: true,
              variant: "danger",
              message: errors[key].message,
              dismissCountDown: 5000,
            });
          }
        }
        _self.loading = false;
      })
      .catch((e) => {
        console.log(e);
        _self.loading = false;
      });
    },
    removeAgenda(agenda_id){
      let _self = this;
      this.loading = "secondary";
      axios.post(`agenda/delete`, {agenda_id:agenda_id})
      .then((response) => {
        let response_data = response.data;
        if (response_data.status) {
          _self.selected = []
          _self.fetchAgenda();
          _self.setAlert({
            show: true,
            variant: "success",
            message: response_data.message,
            dismissCountDown: 5000,
          });
        }
        else {
          let errors = response_data.error;
          for (let key in errors) {
            _self.setAlert({
              show: true,
              variant: "danger",
              message: errors[key].message,
              dismissCountDown: 5000,
            });
          }
        }
        _self.loading = false;
      })
      .catch((e) => {
        console.log(e);
        _self.loading = false;
      });
    },
    openVideo(url){
      this.show_preview = true;
      this.preview_data = url;
    },
    getFileUrl(resource){
      let myself = JSON.parse(localStorage.getItem('flaacos_user'))
      return axios.defaults.baseURL +'file/download?file_id='+ resource.resource_id+'&token='+myself.attendee_token
    }
  },
  mounted: function () {
    this.fetchTotebag();
    this.fetchAdertisement()
    this.fetchAgenda();
  },
};
</script>